module.exports = __webpack_public_path__ + "img/banner-1.5ce4a5eb.png";